import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import("../views/home")
  },
  // 产品中心
  {
    path: '/product/core',
    name: '产品中心-核心优势',
    component: () => import("../views/product/core.vue")
  },
  {
    path: '/product/twin20',
    name: '产品中心-微孪20',
    component: () => import("../views/product/twin20.vue")
  },
  {
    path: '/product/cost',
    name: '产品中心-应用价值',
    component: () => import("../views/product/cost.vue")
  },
  {
    path: '/product/agent',
    name: '产品中心-AI智能体',
    component: () => import("../views/product/agent.vue")
  },
  // 行业应用
  {
    path: '/use/park',
    name: '行业应用-智慧园区',
    component: () => import("../views/use/park.vue")
  },
  {
    path: '/use/building',
    name: '行业应用-智慧楼宇',
    component: () => import("../views/use/building.vue")
  },
  {
    path: '/use/project',
    name: '行业应用-智慧工业',
    component: () => import("../views/use/project.vue")
  },
  {
    path: '/use/traffic',
    name: '行业应用-轨道交通',
    component: () => import("../views/use/traffic.vue")
  },
  {
    path: '/use/school',
    name: '行业应用-智慧高校',
    component: () => import("../views/use/school.vue")
  },
  {
    path: '/use/airport',
    name: '行业应用-智慧机场',
    component: () => import("../views/use/airport.vue")
  },
  {
    path: '/use/hospital',
    name: '行业应用-智慧医院',
    component: () => import("../views/use/hospital.vue")
  },

  // 经典案例
  {
    path: '/case',
    name: '经典案例',
    component: () => import("../views/case")
  },

  // 关于我们
  {
    path: '/towe',
    name: '关于我们',
    component: () => import("../views/toWe")
  }
 
]

const router = new VueRouter({
  routes
})



export default router
